module.exports = __webpack_public_path__ + "mollycoddlers.png?291190572df1d70a7048a80713ac091e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/mollycoddlers.png
// module id = 121
// module chunks = 0